export const CALCULATIONS = {
  EARTH_RADIUS_METERS: 6371e3,
}

export const SUGGESTED_DEFAULTS = {
  MAX_SUGGESTION_DISTANCE_IN_METERS: 2 * 1000, // 2 kms
}

export const MILLISECONDS_PER_DAY = 86400000
export const MILLISECONDS_PER_MONTH = 2628000000
export const MILLISECONDS_PER_YEAR = 31556952000
